import { ReactComponent } from "./arrow-drop-up-fill.svg";

const ArrowDropUpFillIcon = () => <ReactComponent />;

export default ArrowDropUpFillIcon;
